import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Icon
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { currencyFormatter } from "../../../../hooks/currencyFormatter";
import { format } from "date-fns";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useDispatch, useSelector } from "react-redux";
import { getCurrency } from "../../../../reduxToolkit/features/adminPanel/misc";
import getSymbolFromCurrency from "currency-symbol-map";

const CourierListEntry = ({
  courierListEntries,
  setCourierListEntries,
  editable,
}) => {
  const dispatch = useDispatch();
  // Media Query
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  const { currencyList } = useSelector((state) => state.misc);

  useEffect(() => {
    if (!(currencyList && currencyList.length > 0)) dispatch(getCurrency());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCurrencySymbol = (index) => {
    let symbol = "";

    if (courierListEntries[index].currencyTypeId) {
      const currency = currencyList.find(
        (c) => c._id === courierListEntries[index].currencyTypeId
      );
      if (currency) {
        symbol = getSymbolFromCurrency(currency.currencyName);
      }
    }
    return symbol;
  };

  const [editMode, setEditMode] = useState(null);
  const initialEditBuffer = {
    productName: "",
    productQty: "",
    amount: "",
    shippingMethod: "",
    destination: "",
    isPaid: false,
    date: new Date().toString(),
    currencyTypeId: "",
  };
  const [editBuffer, setEditBuffer] = useState(initialEditBuffer);

  const handleEditEntry = (index) => {
    setEditMode(index);
    setEditBuffer({
      productName: courierListEntries[index].productName,
      productQty: courierListEntries[index].productQty,
      weight: courierListEntries[index].weight,
      amount: courierListEntries[index].amount,
      shippingMethod: courierListEntries[index].shippingMethod,
      destination: courierListEntries[index].destination,
      isPaid: courierListEntries[index].isPaid,
      date: courierListEntries[index].date,
      currencyTypeId: courierListEntries[index].currencyTypeId,
    });
  };

  const handleEntryChange = (e, key, isNumeric) => {
    let obj = { ...editBuffer };
    if (isNumeric) obj[key] = e.target.value.replace(/\D/g, "");
    else obj[key] = e.target.value;
    setEditBuffer(obj);
  };

  const handleUpdateEntry = (index) => {
    let arr = [...courierListEntries];
    arr[index] = { ...editBuffer };
    arr = arr.sort((a, b) => (new Date(a.date) > new Date(b.date) ? 1 : -1));
    setCourierListEntries(arr);
    setEditMode(null);
    setEditBuffer(initialEditBuffer);
  };

  const handleRemoveEntry = (index) => {
    let arr = [...courierListEntries];
    arr = arr.filter((a, i) => i !== index);
    setCourierListEntries(arr);
  };
  return (
    <>
      {mdUp && (
        <>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
            sx={{ px: 2, py: 1 }}
          >
            <Grid item xs={1.5}>
              <Typography
                sx={{
                  textAlign: "left",
                }}
                color="text.primary"
                variant="body2"
              >
                Date
              </Typography>
            </Grid>
            <Grid item xs={editable ? 2 : 2.5}>
              <Typography
                sx={{ textTransform: "capitalize", textAlign: "left" }}
                color="text.primary"
                variant="body2"
              >
                Product
              </Typography>
            </Grid>

            <Grid item xs={editable ? 1.25 : 2.25}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Destination
              </Typography>
            </Grid>
            <Grid item xs={1.25}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Shipping
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Weight
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Qty
              </Typography>
            </Grid>
            <Grid item xs={1.5}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Amount
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography
                sx={{ textAlign: "center" }}
                color="text.primary"
                variant="body2"
              >
                Status
              </Typography>
            </Grid>

            {editable && (
              <Grid item xs={1.5}>
                <Typography
                  sx={{
                    textAlign: "right",
                    mr: 2,
                  }}
                  color="text.primary"
                  variant="body2"
                >
                  Action
                </Typography>
              </Grid>
            )}
          </Grid>
          <Divider />
        </>
      )}
      <Box
        sx={{
          height: !editable ? "85%" : !mdUp ? "500px" : "300px",
          overflowY: "auto",
        }}
      >
        {courierListEntries.map((entry, index) => (
          <Fragment key={index}>
            <Grid
              container
              justifyContent="space-between"
              alignItems="center"
              sx={{ px: 2, py: 1 }}
            >
              <Grid item xs={12} lg={1.5}>
                {editMode === index ? (
                  <Box>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <MobileDatePicker
                        label={!mdUp && "Date"}
                        value={editBuffer.date}
                        onChange={(newValue) => {
                          let obj = { ...editBuffer };
                          obj.date = newValue;
                          setEditBuffer(obj);
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            fullWidth
                            sx={{ pr: !mdUp ? 0 : 1, py: 1 }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                ) : (
                  <Typography
                    sx={{
                      textAlign: "left",
                    }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Date: "}
                    {format(new Date(entry.date), "dd-MM-y")}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} lg={editable ? 2 : 2.5}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Product"}
                    value={editBuffer.productName}
                    onChange={(e) => handleEntryChange(e, "productName")}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ pr: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textTransform: "capitalize" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Product: "}
                    {entry.productName}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} lg={editable ? 1.25 : 2.25}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Destination"}
                    value={editBuffer.destination}
                    onChange={(e) => handleEntryChange(e, "destination")}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ px: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: !mdUp ? "left" : "center" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Destination: "}
                    {entry.destination}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} lg={1.25}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Shipping"}
                    value={editBuffer.shippingMethod}
                    onChange={(e) => handleEntryChange(e, "shippingMethod")}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ px: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: !mdUp ? "left" : "center" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Shipping: "}
                    {entry.shippingMethod}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} lg={1}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Weight"}
                    value={editBuffer.weight}
                    onChange={(e) => handleEntryChange(e, "weight")}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ pr: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: !mdUp ? "left" : "center" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Weight: "}
                    {entry.weight}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} lg={1}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Qty"}
                    value={editBuffer.productQty}
                    onChange={(e) => handleEntryChange(e, "productQty", true)}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ pr: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: !mdUp ? "left" : "center" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Qty: "}
                    {entry.productQty}
                  </Typography>
                )}
              </Grid>
              <Grid item xs={12} lg={1.5}>
                {editMode === index ? (
                  <TextField
                    label={!mdUp && "Amount"}
                    value={editBuffer.amount}
                    onChange={(e) => handleEntryChange(e, "amount", true)}
                    size="small"
                    variant="outlined"
                    fullWidth
                    sx={{ px: !mdUp ? 0 : 1, py: 1 }}
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: !mdUp ? "left" : "center" }}
                    color="text.secondary"
                    variant="body2"
                  >
                    {!mdUp && "Amount: "}
                    {getCurrencySymbol(index)}
                    {currencyFormatter("usd", entry.amount)}
                  </Typography>
                )}
              </Grid>

              <Grid
                item
                xs={12}
                lg={1}
                sx={{
                  display: "flex",
                  justifyContent: !mdUp ? "start" : "center",
                  alignItems: "center",
                }}
              >
                {editMode === index ? (
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={editBuffer.isPaid}
                        onChange={(e) => {
                          let obj = { ...editBuffer };
                          obj.isPaid = e.target.checked;
                          setEditBuffer(obj);
                        }}
                        sx={{ ml: !mdUp ? 0 : 2, py: 1 }}
                      />
                    }
                    label="Paid"
                  />
                ) : (
                  <Typography
                    sx={{ textAlign: "center" }}
                    color={entry.isPaid ? "success" : "error"}
                    variant="body2"
                  >
                    {entry.isPaid ? "Paid" : "Not Paid"}
                  </Typography>
                )}
              </Grid>

              {editable && (
                <Grid item xs={12} lg={1.5}>
                  <Grid
                    container
                    justifyContent="end"
                    alignItems="end"
                    spacing={1}
                  >
                    <Grid item>
                      {editMode === index ? (
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => setEditMode(null)}
                        >
                          <CancelIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          color="error"
                          size="small"
                          onClick={() => handleRemoveEntry(index)}
                        >
                          <DeleteRoundedIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      )}
                    </Grid>
                    <Grid item>
                      {editMode === index ? (
                        <IconButton
                          color="success"
                          size="small"
                          onClick={() => handleUpdateEntry(index)}
                        >
                          <CheckCircleIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      ) : (
                        <IconButton
                          color="info"
                          size="small"
                          onClick={() => handleEditEntry(index)}
                        >
                          <EditRoundedIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Divider />
          </Fragment>
        ))}
      </Box>
    </>
  );
};

export default CourierListEntry;
